import styled from 'styled-components';
import {
  regularFont,
  screenSize,
  primaryColor,
  primaryHoverColor,
  secondaryColor,
  secondaryActiveColor,
} from '@app/styles';
import DefaultImageUrl from '@app/assets/images/user_profile.svg';

type ImageProps = {
  image?: string;
  borderRadius?: string;
  isProfile?: boolean
};

export const UploaderContainer = styled.div``;

export const UploaderInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  @media (${screenSize.tablet}) {
    margin-left: 10px;
    width: 90%;
  }
  ${({ isProfile }: ImageProps) => {
    if (isProfile) {
      return `position:absolute;
      bottom:0;
      width:100%;
      @media (${screenSize.tablet}) {
        margin: 0px;
        width:100%;
      }`
    }
  }}
`;
export const ImageUploader = styled.div`
  height: 60px;
  width: 80px;
  background: #fff;
  border-radius: 6px;
  margin-bottom: 15px;
  padding: 0 15px 0 0;
  display: flex;
  align-items: center;
  margin-top: 5px;
  @media (${screenSize.tablet}) {
    min-height: 64px;
    padding: 0;
    width:100%;
    background: inherit;
  }
  ${({ isProfile }: ImageProps) => {
    if (isProfile) {
      return `position:relative;
      height:80px;
      @media (${screenSize.tablet}) {
        min-height: 120px;
        width:120px;
      }`
    }
  }}
`;

export const ProfileImage = styled.div`
    background-color:rgb(222 228 238);
    border:1px solid #ccc;
     margin-right:10px;
    background-image:url(${DefaultImageUrl});
    background-position:center;
    background-repeat:no-repeat;
    background-size:cover;
    ${({ image }: ImageProps) => {
    if (image) {
      return `background-image:url(${image});`;
    }
  }}
    @media (${screenSize.tablet}){
        height:64px;
        width:64px;      
    }
    ${({ isProfile }: ImageProps) => {
    if (isProfile) {
      return `min-height:80px;
                  min-width:80px;
                  @media (${screenSize.tablet}){
                    min-width:120px;
                    min-height:120px;
                  }`
    } else {
      return `min-width:64px;
                min-height:64px;`
    }
  }}
    ${({ borderRadius }: ImageProps) => {
    if (borderRadius) {
      return `border-radius:${borderRadius};`;
    } else {
      return `border-radius:50%;`;
    }
  }};  
`;
export const UploadText = styled.div`
  ${regularFont};
  font-size: 14px;
  color: ${primaryColor};
  position: relative;
  margin: 0 5px;
  cursor: pointer;
  &:hover {
    color: ${primaryHoverColor};
  }
  ${({ isProfile }: ImageProps) => {
    if (isProfile) {
      return `margin:0;`
    }
  }}
`;

export const HiddenInput = styled.input`
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  font-size: 0;
  position: absolute;
`;
export const Label = styled.label`
  font-size: 15px;
  color: #6b6f8c;
  line-height: 21px;
  @media (${screenSize.tablet}) {
    padding: 8px;
  }
`;

export const Name = styled.div`
  width: 60%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  margin: 5px 5px;
  @media (${screenSize.tablet}) {
    width: 300px;
  }
`;

export const CloseIcon = styled.div`
  cursor: pointer;
  padding-top: 2px;
  padding-right: 20px;
  color: ${secondaryColor};
  &:hover {
    color: ${secondaryActiveColor};
  }
`;
export const ChangeButton = styled.div`
  background-color: #edeff3;
  color: #72757d;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  ${({ isProfile }: ImageProps) => {
    if (isProfile) {
      return `padding: 4px;
      background-color:rgba(0,0,0,0.6);
      text-align:center;
      color:#fff;
      border-radius:0px;
      border-bottom-right-radius:6px;
      border-bottom-left-radius:6px;`
    }
  }}
`;
